import React, { useContext } from 'react';

import * as S from './FooterStyle';
import { ResponsiveContainer } from 'commonStyles';
import { FooterLinks } from './config';
import DisplayContext from 'UtilityComponents/displayContext';
import { isMobileContext, trackClickEvents } from 'UtilityComponents/Util';
import { LandingSpriteIcon } from './Styles';

const Footer = () => {
	const displayName = useContext(DisplayContext).isMobile;
	const isMobile = isMobileContext(displayName);
	return (
		<S.FooterWrapper>
			<ResponsiveContainer
				wrap='wrap'
				justify='space-between'
				isFlex='true'>
				{FooterLinks.map((section, i) => (
					<S.FooterColWrap key={section.head}>
						<LandingSpriteIcon icon={section.icon} />
						<S.FooterLabel>{section.head}</S.FooterLabel>
						<ul onClick={() => trackClickEvents(section.trackVal)}>
							{section.list.map((lnk, i) => (
								<S.FooterItems key={lnk.url + lnk.text + i}>
									<a href={lnk.url}>{lnk.text}{lnk.img && <img width='128' height='36' src={isMobile && lnk.mobileImg ? lnk.mobileImg : lnk.img} alt={lnk.alt} />}</a>
								</S.FooterItems>
							))}
						</ul>
					</S.FooterColWrap>
				))}
			</ResponsiveContainer>
		</S.FooterWrapper>
	);
};

export default Footer;
